import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { loadMovieThunk } from '@common/redux/slices/movies.slice';
import { loadRecommendationsMoviesForMovies } from '@common/redux/slices/recommendation.slice';
import { SingleMovie } from '@kursk/components/pages/SingleMovie/SingleMovie';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';

export default function Movie({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return (
    <SingleMovie />
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch<any>(loadMovieThunk({ id })),
    store.dispatch<any>(loadRecommendationsMoviesForMovies({ _id: id })),
  ]);
  const { movie } = store.getState().moviesList;

  if (!movie?._id) {
    return {
      props: { notFound: true }
    };
  }
});
